(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["f-expertise"] && !Shopify.designMode) return;
  try {
    
  class FExpertise extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[data-expertise-tab]'))

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.activate(tab, true))
        tab.addEventListener('focus', () => this.activate(tab))
        tab.addEventListener('pointerenter', () => {
          if (window.matchMedia('(min-width: 750px) and (hover: hover)').matches) {
            this.activate(tab)
          }
        })
        tab.addEventListener('keydown', (event) => this.handleKeydown(event))
      })
    }

    activate(activeTab, shouldScroll = false) {
      this.tabs.forEach((tab) => {
        const isActive = tab === activeTab
        const panel = this.querySelector(`#${tab.dataset.panelId}`)

        tab.classList.toggle('is-active', isActive)
        tab.setAttribute('aria-selected', isActive.toString())
        tab.tabIndex = isActive ? 0 : -1

        if (panel) panel.hidden = !isActive
      })

      if (shouldScroll && window.matchMedia('(max-width: 749px)').matches) {
        activeTab.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' })
      }
    }

    handleKeydown(event) {
      if (!['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'].includes(event.key)) return

      event.preventDefault()
      const currentIndex = this.tabs.indexOf(event.currentTarget)
      let nextIndex = currentIndex

      if (event.key === 'Home') nextIndex = 0
      if (event.key === 'End') nextIndex = this.tabs.length - 1
      if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
        nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length
      }
      if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
        nextIndex = (currentIndex + 1) % this.tabs.length
      }

      this.tabs[nextIndex].focus()
    }
  }

  if (!customElements.get('f-expertise')) {
    customElements.define('f-expertise', FExpertise)
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["f-galeria-proyecto"] && !Shopify.designMode) return;
  try {
    
  class ProjectGallerySlider extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('[data-project-gallery-slide]'))
      this.controls = Array.from(this.querySelectorAll('[data-project-gallery-control]'))
      this.pagination = this.querySelector('[data-project-gallery-pagination]')
      this.slidesContainer = this.querySelector('.f-project-gallery__slides')
      this.currentIndex = this.slides.findIndex((slide) => !slide.hidden)

      if (this.currentIndex < 0) {
        this.currentIndex = 0
      }

      this.controls.forEach((control) => {
        control.addEventListener('click', () => {
          this.setActiveSlide(Number(control.dataset.index))
        })
      })

      if (this.pagination && this.controls.length > 1) {
        this.onPointerMoveBound = this.onPointerMove.bind(this)
        this.onPointerUpBound = this.onPointerUp.bind(this)

        this.pagination.addEventListener('pointerdown', this.onPointerDown.bind(this))
      }

      if (this.slidesContainer && this.slides.length > 1) {
        this.onSlidePointerMoveBound = this.onSlidePointerMove.bind(this)
        this.onSlidePointerUpBound = this.onSlidePointerUp.bind(this)

        this.slidesContainer.addEventListener('pointerdown', this.onSlidePointerDown.bind(this))
      }
    }

    onSlidePointerDown(event) {
      if (!window.matchMedia('(max-width: 749px)').matches) return

      this.isSwipingSlide = true
      this.slideStartX = event.clientX
      this.slideStartY = event.clientY
      this.slidePointerId = event.pointerId

      try {
        this.slidesContainer.setPointerCapture(event.pointerId)
      } catch (error) {
        // Pointer capture can fail for synthetic events; the window listeners still handle the swipe.
      }
      window.addEventListener('pointermove', this.onSlidePointerMoveBound)
      window.addEventListener('pointerup', this.onSlidePointerUpBound, { once: true })
      window.addEventListener('pointercancel', this.onSlidePointerUpBound, { once: true })
    }

    onSlidePointerMove(event) {
      if (!this.isSwipingSlide) return

      const deltaX = event.clientX - this.slideStartX
      const deltaY = event.clientY - this.slideStartY

      if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > 8) {
        event.preventDefault()
      }
    }

    onSlidePointerUp(event) {
      if (!this.isSwipingSlide) return

      const deltaX = event.clientX - this.slideStartX
      const deltaY = event.clientY - this.slideStartY
      const threshold = Math.min(this.slidesContainer.offsetWidth * 0.2, 80)

      this.isSwipingSlide = false
      window.removeEventListener('pointermove', this.onSlidePointerMoveBound)

      if (this.slidesContainer.hasPointerCapture && this.slidesContainer.hasPointerCapture(this.slidePointerId)) {
        this.slidesContainer.releasePointerCapture(this.slidePointerId)
      }

      if (Math.abs(deltaX) <= Math.abs(deltaY) || Math.abs(deltaX) < threshold) return

      if (deltaX < 0) {
        this.setActiveSlide(Math.min(this.currentIndex + 1, this.slides.length - 1))
      } else {
        this.setActiveSlide(Math.max(this.currentIndex - 1, 0))
      }
    }

    onPointerDown(event) {
      event.preventDefault()
      this.isDragging = true
      this.dragTarget = event.currentTarget
      this.pagination.classList.add('is-dragging')

      if (this.dragTarget.setPointerCapture) {
        this.dragTarget.setPointerCapture(event.pointerId)
      }

      window.addEventListener('pointermove', this.onPointerMoveBound)
      window.addEventListener('pointerup', this.onPointerUpBound, { once: true })
      window.addEventListener('pointercancel', this.onPointerUpBound, { once: true })
      this.setActiveSlideFromPointer(event)
    }

    onPointerMove(event) {
      if (!this.isDragging) return

      this.setActiveSlideFromPointer(event)
    }

    onPointerUp(event) {
      if (!this.isDragging) return

      this.isDragging = false
      this.pagination.classList.remove('is-dragging')

      window.removeEventListener('pointermove', this.onPointerMoveBound)

      if (this.dragTarget.hasPointerCapture && this.dragTarget.hasPointerCapture(event.pointerId)) {
        this.dragTarget.releasePointerCapture(event.pointerId)
      }

      this.dragTarget = null
    }

    setActiveSlideFromPointer(event) {
      const rect = this.pagination.getBoundingClientRect()
      const progress = Math.min(Math.max((event.clientX - rect.left) / rect.width, 0), 0.999)
      const index = Math.floor(progress * this.controls.length)

      this.setActiveSlide(index)
    }

    setActiveSlide(index) {
      this.currentIndex = index

      this.slides.forEach((slide, slideIndex) => {
        const isActive = slideIndex === index
        slide.hidden = !isActive
        slide.classList.toggle('is-active', isActive)
      })

      this.controls.forEach((control, controlIndex) => {
        const isActive = controlIndex === index
        control.classList.toggle('is-active', isActive)

        if (isActive) {
          control.setAttribute('aria-current', 'true')
        } else {
          control.removeAttribute('aria-current')
        }
      })

    }
  }

  if (!customElements.get('project-gallery-slider')) {
    customElements.define('project-gallery-slider', ProjectGallerySlider)
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["f-grid-proyectos"] && !Shopify.designMode) return;
  try {
    
  class FGridProyectos extends HTMLElement {
    connectedCallback() {
      this.step = Number(this.dataset.step) || 4
      this.visibleCount = Number(this.dataset.initial) || 8

      this.viewButtons = Array.from(this.querySelectorAll('[data-view-toggle]'))
      this.panels = Array.from(this.querySelectorAll('[data-view-panel]'))
      this.cards = Array.from(this.querySelectorAll('[data-project-card]'))
      this.rows = Array.from(this.querySelectorAll('[data-project-row]'))
      this.images = Array.from(this.querySelectorAll('[data-project-image]'))
      this.loadMoreButton = this.querySelector('[data-load-more]')
      this.listLayout = this.querySelector('[data-project-layout]')
      this.listPanel = this.querySelector('[data-view-panel="list"]')
      this.autoplayDelay = Number(this.dataset.autoplay) || 0
      this.activeIndex = 0
      this.hoverQuery = window.matchMedia('(hover: hover) and (min-width: 750px)')

      this.viewButtons.forEach((button) => {
        button.addEventListener('click', () => this.setView(button.dataset.viewToggle))
      })

      if (this.loadMoreButton) {
        this.loadMoreButton.addEventListener('click', () => this.showMore())
      }

      if (this.listLayout) {
        this.listLayout.addEventListener('pointerleave', () => this.hideHoverMedia())
        this.listLayout.addEventListener('focusout', (event) => {
          if (!this.listLayout.contains(event.relatedTarget)) this.hideHoverMedia()
        })
      }

      this.rows.forEach((row) => {
        const trigger = row.querySelector('[data-project-trigger]')
        if (!trigger) return

        const index = Number(row.dataset.index)

        trigger.addEventListener('pointerenter', () => {
          if (this.hoverQuery.matches) this.showHoverMedia(row, index)
        })

        trigger.addEventListener('focus', () => this.showHoverMedia(row, index))
      })

      this.startAutoplay()
    }

    disconnectedCallback() {
      this.stopAutoplay()
    }

    setView(view) {
      this.panels.forEach((panel) => {
        panel.hidden = panel.dataset.viewPanel !== view
      })

      this.viewButtons.forEach((button) => {
        const isActive = button.dataset.viewToggle === view
        button.classList.toggle('is-active', isActive)
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false')
      })
    }

    showMore() {
      this.visibleCount += this.step

      this.cards.forEach((card, index) => {
        if (index < this.visibleCount) card.hidden = false
      })

      if (this.loadMoreButton && this.visibleCount >= this.cards.length) {
        this.loadMoreButton.hidden = true
      }
    }

    setActiveProject(index) {
      this.rows.forEach((row) => {
        row.classList.toggle('is-active', Number(row.dataset.index) === index)
      })

      this.images.forEach((image) => {
        const isActive = Number(image.dataset.index) === index
        image.classList.toggle('is-active', isActive)
        image.tabIndex = isActive ? 0 : -1
        image.setAttribute('aria-hidden', isActive ? 'false' : 'true')
      })

      this.activeIndex = index
    }

    startAutoplay() {
      if (this.autoplayDelay <= 0 || this.images.length < 2) return

      this.stopAutoplay()
      this.autoplayTimer = window.setInterval(() => {
        // Autoplay is a mobile-only behaviour; on desktop the image follows the hovered row.
        if (this.hoverQuery.matches || (this.listPanel && this.listPanel.hidden) || document.hidden) return

        const next = (Number(this.activeIndex) + 1) % this.images.length
        this.setActiveProject(next)
      }, this.autoplayDelay * 1000)
    }

    stopAutoplay() {
      if (this.autoplayTimer) window.clearInterval(this.autoplayTimer)
      this.autoplayTimer = null
    }

    showHoverMedia(row, index) {
      this.setActiveProject(index)

      if (!this.listLayout) return

      const layoutTop = this.listLayout.getBoundingClientRect().top
      const rowRect = row.getBoundingClientRect()

      this.listLayout.style.setProperty('--f-projects-media-top', `${rowRect.top - layoutTop + rowRect.height / 2}px`)
      this.listLayout.classList.add('is-hovering')
    }

    hideHoverMedia() {
      if (this.listLayout) this.listLayout.classList.remove('is-hovering')
    }
  }

  if (!customElements.get('f-grid-proyectos')) {
    customElements.define('f-grid-proyectos', FGridProyectos)
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["f-hero-columnas"] && !Shopify.designMode) return;
  try {
    
  class HeroColumns extends HTMLElement {
    connectedCallback() {
      this.columns = Array.from(this.querySelectorAll('[data-hero-columns-column]'))
      this.pointerCoarse = window.matchMedia('(hover: none), (pointer: coarse)')

      if (this.pointerCoarse.matches && this.columns.length && !this.columns.some((column) => column.classList.contains('is-open'))) {
        this.columns[0].classList.add('is-open')
        this.columns[0].setAttribute('aria-expanded', 'true')
      }

      this.columns.forEach((column) => {
        column.addEventListener('click', (event) => {
          if (!this.pointerCoarse.matches) return

          event.preventDefault()
          const isOpen = column.classList.contains('is-open')

          this.columns.forEach((other) => {
            other.classList.remove('is-open')
            other.setAttribute('aria-expanded', 'false')
          })

          if (!isOpen) {
            column.classList.add('is-open')
            column.setAttribute('aria-expanded', 'true')
          }
        })
      })
    }
  }

  customElements.define('hero-columns', HeroColumns)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["f-hero-partido"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const SELECTORS = {
      section: '[data-f-hero-split]',
      option: '[data-f-hero-split-option]',
      panel: '[data-f-hero-split-panel]',
      optionsList: '[data-f-hero-split-options]',
      nextTrigger: '[data-f-hero-split-next]',
    };

    const DESKTOP_QUERY = '(hover: hover) and (min-width: 750px)';

    function activatePanel(root, index) {
      const options = root.querySelectorAll(SELECTORS.option);
      const panels = root.querySelectorAll(SELECTORS.panel);

      options.forEach((option, optionIndex) => {
        const isActive = optionIndex === index;
        option.classList.toggle('is-active', isActive);
        option.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      panels.forEach((panel) => {
        const isActive = Number(panel.dataset.fHeroSplitIndex) === index;
        panel.classList.toggle('is-active', isActive);
        panel.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      });
    }

    function scrollToNextSection(root) {
      const currentSection = root.closest('.shopify-section');
      if (!currentSection) return;

      let nextSection = currentSection.nextElementSibling;
      while (nextSection && !nextSection.id.startsWith('shopify-section-')) {
        nextSection = nextSection.nextElementSibling;
      }

      if (nextSection) {
        nextSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }

    function setup(root) {
      if (root.dataset.fHeroSplitReady === 'true') return;

      const options = root.querySelectorAll(SELECTORS.option);
      const panels = root.querySelectorAll(SELECTORS.panel);
      const optionsList = root.querySelector(SELECTORS.optionsList);
      const nextTrigger = root.querySelector(SELECTORS.nextTrigger);

      if (!options.length || !panels.length) return;

      options.forEach((option, index) => {
        option.addEventListener('click', () => {
          activatePanel(root, index);

          if (window.matchMedia('(max-width: 749px)').matches && optionsList) {
            option.parentElement?.scrollIntoView({
              behavior: 'smooth',
              inline: 'center',
              block: 'nearest',
            });
          }
        });

        option.addEventListener('focus', () => activatePanel(root, index));

        option.addEventListener('mouseenter', () => {
          if (!window.matchMedia(DESKTOP_QUERY).matches) return;
          activatePanel(root, index);
        });
      });

      if (nextTrigger) {
        nextTrigger.addEventListener('click', (event) => {
          event.preventDefault();
          scrollToNextSection(root);
        });
      }

      activatePanel(root, 0);
      root.dataset.fHeroSplitReady = 'true';
    }

    function init() {
      document.querySelectorAll(SELECTORS.section).forEach(setup);
    }

    init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["f-hero-proyectos"] && !Shopify.designMode) return;
  try {
    
  class HeroOptions extends HTMLElement {
    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('[data-hero-option]'))
      this.segments = Array.from(this.querySelectorAll('[data-hero-segment]'))
      this.list = this.querySelector('[data-hero-track]')
      this.pointerFine = window.matchMedia('(hover: hover) and (pointer: fine)')
      this.currentIndex = 0

      this.items.forEach((item, index) => {
        const trigger = item.querySelector('[data-hero-trigger]')

        trigger.addEventListener('click', () => this.setActiveOption(index))
        trigger.addEventListener('focus', () => this.setActiveOption(index))
        item.addEventListener('pointerenter', (event) => {
          if (event.pointerType === 'mouse' && this.pointerFine.matches) {
            this.setActiveOption(index)
          }
        })
      })

      this.segments.forEach((segment, index) => {
        segment.addEventListener('click', () => this.setActiveOption(index))
      })

      if (this.segments.length > 1) {
        this.onPointerMoveBound = this.onPointerMove.bind(this)
        this.onPointerUpBound = this.onPointerUp.bind(this)
        this.onPointerDownBound = this.onPointerDown.bind(this)
        this.segments.forEach((segment) => segment.addEventListener('pointerdown', this.onPointerDownBound))
      }

      this.reserveHeight()
      this.onResizeBound = this.onResize.bind(this)
      window.addEventListener('resize', this.onResizeBound)

      this.onBlockSelectBound = this.onBlockSelect.bind(this)
      document.addEventListener('shopify:block:select', this.onBlockSelectBound)

      if (document.fonts) {
        document.fonts.ready.then(() => this.reserveHeight())
      }
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.onResizeBound)
      document.removeEventListener('shopify:block:select', this.onBlockSelectBound)
    }

    onBlockSelect(event) {
      const index = this.items.indexOf(event.target)

      if (index >= 0) {
        this.setActiveOption(index)
      }
    }

    onResize() {
      clearTimeout(this.resizeTimeout)
      this.resizeTimeout = setTimeout(() => this.reserveHeight(), 200)
    }

    // The tallest option defines a fixed height so switching options never shifts the block.
    reserveHeight() {
      if (!this.list || this.items.length < 2) return

      const activeIndex = this.currentIndex
      let tallest = 0

      this.classList.add('is-measuring')
      this.list.style.minHeight = ''

      this.items.forEach((_, index) => {
        this.applyActiveState(index)
        tallest = Math.max(tallest, this.list.offsetHeight)
      })

      this.applyActiveState(activeIndex)
      this.list.style.minHeight = `${tallest}px`
      this.classList.remove('is-measuring')
    }

    onPointerDown(event) {
      event.preventDefault()
      this.isDragging = true
      this.dragTarget = event.currentTarget
      this.list.classList.add('is-dragging')

      if (this.dragTarget.setPointerCapture) {
        this.dragTarget.setPointerCapture(event.pointerId)
      }

      window.addEventListener('pointermove', this.onPointerMoveBound)
      window.addEventListener('pointerup', this.onPointerUpBound, { once: true })
      window.addEventListener('pointercancel', this.onPointerUpBound, { once: true })
      this.setActiveOptionFromPointer(event)
    }

    onPointerMove(event) {
      if (!this.isDragging) return

      this.setActiveOptionFromPointer(event)
    }

    onPointerUp(event) {
      if (!this.isDragging) return

      this.isDragging = false
      this.list.classList.remove('is-dragging')
      window.removeEventListener('pointermove', this.onPointerMoveBound)

      if (this.dragTarget.hasPointerCapture && this.dragTarget.hasPointerCapture(event.pointerId)) {
        this.dragTarget.releasePointerCapture(event.pointerId)
      }

      this.dragTarget = null
    }

    // Segments have different heights, so the pointer maps to the closest segment instead of a fixed ratio.
    setActiveOptionFromPointer(event) {
      let closestIndex = this.currentIndex
      let closestDistance = Infinity

      this.segments.forEach((segment, index) => {
        const rect = segment.getBoundingClientRect()
        const distance = Math.abs(event.clientY - (rect.top + rect.height / 2))

        if (event.clientY >= rect.top && event.clientY <= rect.bottom) {
          closestDistance = 0
          closestIndex = index
        } else if (distance < closestDistance) {
          closestDistance = distance
          closestIndex = index
        }
      })

      this.setActiveOption(closestIndex)
    }

    setActiveOption(index) {
      if (index === this.currentIndex) return

      this.currentIndex = index
      this.applyActiveState(index)
    }

    applyActiveState(index) {
      this.items.forEach((item, itemIndex) => {
        const isActive = itemIndex === index
        const trigger = item.querySelector('[data-hero-trigger]')

        item.classList.toggle('is-active', isActive)
        trigger.setAttribute('aria-expanded', isActive ? 'true' : 'false')
      })

      this.segments.forEach((segment, segmentIndex) => {
        const isActive = segmentIndex === index

        segment.classList.toggle('is-active', isActive)

        if (isActive) {
          segment.setAttribute('aria-current', 'true')
        } else {
          segment.removeAttribute('aria-current')
        }
      })
    }
  }

  if (!customElements.get('hero-options')) {
    customElements.define('hero-options', HeroOptions)
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["f-slide-proyectos"] && !Shopify.designMode) return;
  try {
    
  class FSlideProyectos extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('[data-slides]')
      this.slides = Array.from(this.querySelectorAll('[data-slide]'))
      this.dots = Array.from(this.querySelectorAll('[data-slide-dot]'))
      this.prevButton = this.querySelector('[data-slide-prev]')
      this.nextButton = this.querySelector('[data-slide-next]')
      this.index = 0

      if (!this.viewport || this.slides.length === 0) return

      this.prevButton?.addEventListener('click', () => this.goTo(this.index - 1))
      this.nextButton?.addEventListener('click', () => this.goTo(this.index + 1))

      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => this.goTo(Number(dot.dataset.index)))
      })

      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) this.setActive(Number(entry.target.dataset.index))
          })
        },
        { root: this.viewport, threshold: 0.6 }
      )

      this.slides.forEach((slide) => this.observer.observe(slide))
      this.setActive(0)
    }

    disconnectedCallback() {
      this.observer?.disconnect()
    }

    goTo(index) {
      const targetIndex = (index + this.slides.length) % this.slides.length
      const target = this.slides[targetIndex]
      if (!target) return

      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches

      this.viewport.scrollTo({
        left: target.offsetLeft - this.viewport.offsetLeft,
        behavior: reduceMotion ? 'auto' : 'smooth',
      })
    }

    setActive(index) {
      this.index = index

      this.dots.forEach((dot) => {
        const isActive = Number(dot.dataset.index) === index
        dot.classList.toggle('is-active', isActive)
        dot.setAttribute('aria-selected', isActive ? 'true' : 'false')
      })

    }
  }

  if (!customElements.get('f-slide-proyectos')) {
    customElements.define('f-slide-proyectos', FSlideProyectos)
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
